import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromTranslation from '../translation/translation.reducer'
import { TranslationEffects } from './translation.effects'
import { TranslationSerializer } from './translation.serializer'
import { TranslationService } from './translation.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromTranslation.FEATURE_NAME,
      fromTranslation.translationReducer
    ),
    EffectsModule.forFeature([TranslationEffects])
  ],
  providers: [
    TranslationService,
    {
      provide: TranslationSerializer,
      useClass: TranslationSerializer
    }
  ],
  declarations: []
})
export class TranslationModule {}
